<template>
<div class="lvChatListBox" ref="lvChatListBox" id="lvChatListBox">
<!--  <van-list-->
<!--      v-model:loading="oldLoading"-->
<!--      :finished="oldFinished"-->
<!--      direction="up"-->
<!--      finished-text="没有更多了"-->
<!--      @load="onLoad"-->
<!--  >-->
  <div class="loadMore" ref="refLoadMore" v-show="oldFinished">没有更多了</div>
  <div class="loadMore" ref="refLoadMore" v-show="!oldFinished">加载更多...</div>
    <div v-for="(item, index) in comments">
      <timeChat v-if="item.isShowMsgTime" :time="item.showMsgTime"></timeChat>
      <myChat v-else-if="item.commentType==0&&item.userId==userId" :headImg="item.userImg" :name="item.userName" :text="item.content" :replyName="item.replyUserName"></myChat>
      <giftChat v-else-if="item.commentType==1" :name="item.userName" ></giftChat>
      <otherChat v-else @altSomeOne="altSomeOne" :headImg="item.userImg" :name="item.userName" :userId="item.userId" :text="item.content" :replyName="item.replyUserName"></otherChat>
    </div>
<!--  </van-list>-->

  <div class="refHeight" ref="refHeight"></div>
<!--  <van-pull-refresh v-model="oldLoading" @refresh="onLoad">-->
<!--    <div v-for="(item, index) in comments">-->
<!--      <myChat :ref="`chat${index}`" @headBtn="btn" v-if="item.commentType==0&&item.userId==userId" :headImg="item.userImg" :name="item.userName" :text="item.content"></myChat>-->
<!--      <giftChat :ref="`chat${index}`" v-else-if="item.commentType==1" :name="item.userName" ></giftChat>-->
<!--      <otherChat :ref="`chat${index}`" v-else :headImg="item.userImg" :name="item.userName" :text="item.content"></otherChat>-->
<!--    </div>-->
<!--  </van-pull-refresh>-->

</div>
</template>

<script>
import otherChat from "./chatTmp/otherChat";
import myChat from "./chatTmp/myChat";
import giftChat from "./chatTmp/giftChat";
import {apiLive} from "../../../network/app/apiPlatformLive";
import {scroller} from "../../../js/util/scroller";
import {Toast} from "vant";
import {wxAuth} from "../../../network/wx/wxAuth";
import timeChat from "./chatTmp/timeChat";
import {utils} from "../../../network/utils";
import {actConfig} from "../../../js/activity/actConfig";
import {activity} from "../../../js/activity/getInfo";
import {getActTitles} from "../../../js/activity/activityState";
import {browser} from "../../../js/browser";

export default {
  name: "lvChatList",
  components:{
    otherChat,
    myChat,
    giftChat,
    timeChat
  },
  props:{
    liveId: {
      type: Number,
      required: true,
    },
    isAction: {
      type: Boolean,
      default: false,
    },
  },
  watch:{
    isAction: {
      handler(newVal,oldVal) {
        if((newVal)&&(this.firstAct)){
          this.firstAct = false
          this.userId = wxAuth.getUserId()
          // 第一次激活
          // 获取图文信息
          console.log("第一次激活 聊天列表")
          this.newLoading = false
          this.firstGetOld = true
          this.comments.length = 0

          this.lastTop = 0
          this.lastHeight = window.document.body.parentElement.clientHeight

          this.getCommentNew(true);

        }else if(newVal==false){
          // console.log("chat list act false")
        }else if(newVal==true){
          scroller.scrollTo(window.document.body.parentElement, 0, this.lastTop)
          //定时器
          this.count = 3
          // console.log("chat list act true")
        }
      },
    }
  },
  data(){
    return {
      userId: '0',

      //第一次激活该页面
      firstAct: true,
      //第一次获取最新数据后，解发一次获取旧数据
      firstGetOld: true,

      comments: [],
      //获取最新。。。
      newLoading: false,
      //获取历史或旧数据。。。
      oldLoading: false,
      oldFinished: true,

      limitMax: 10,

      //自适应位置
      needResetPos: 0,  //0没有更新 1获取最新  2获取历史
      lastTop: 0,
      lastHeight: 0,

      //时间
      newMsgTime: 0,
      oldMsgTime: 0,

      //定时器
      timer: '',
      count: 0,

      //记录花的信息
      flower: {
        'count': 0,
        'lastUpdateTime': 0,
        'remainTime': '', //大于等于60不显示
      },

      curScollerElement: null,
    }
  },
  created() {
    // 创建定时器
    this.timer = setInterval(this.intervalCallBack, 1000);
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, false)
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.removeEventListener('scroll', this.onScroll)
  },
  beforeUpdate() {
    // if(this.needResetPos != 0){
    //   console.log("------------------------------beforeUpdate")
    //   console.log("clientHeight"+this.$refs.lvChatListBox.parentElement.clientHeight)
    //   console.log("scrollTop"+this.$refs.lvChatListBox.parentElement.scrollTop)
    //   console.log("scrollHeight"+this.$refs.lvChatListBox.parentElement.scrollHeight)
    //   // this.lastTop = this.$refs.lvChatListBox.parentElement.scrollTop
    //   // this.lastHeight = this.$refs.lvChatListBox.parentElement.scrollHeight
    // }
  },
  updated() {
    let element = this.getElement()

    if(this.needResetPos == 3){ //下拉刷新
      this.lastTop += (element.scrollHeight - this.lastHeight)
      scroller.scrollTo(element, 0, this.lastTop)
    }else if(this.needResetPos == 2){ //获取新数据刷新
      let det = this.lastHeight - this.lastTop
      det = det - element.clientHeight
      if((this.$refs.refHeight.scrollHeight*5)>det){
        scroller.smoothScroll(element, 0, element.scrollHeight-element.clientHeight)
      }
    }
    else if(this.needResetPos == 1){ //首次刷新
      //兼容问题
      scroller.scrollTo(document.documentElement, 0, element.scrollHeight)
      scroller.scrollTo(document.body, 0, element.scrollHeight)
    }

    if(this.needResetPos != 0){
      this.needResetPos = 0
    }
  },
  methods:{
    getElement(){
      if(this.curScollerElement != null ){
        return this.curScollerElement
      }
      if(document.documentElement.scrollTop!=0){
        this.curScollerElement = document.documentElement
      }else if(document.body.scrollTop!=0){
        this.curScollerElement = document.body
      }

      if(this.curScollerElement != null ){
        return this.curScollerElement
      }else{
        if(browser.getAppSys()==1){ //安卓
          return document.body
        }else{
          return document.documentElement
        }
      }
    },
    onScroll(){
      if(!this.isAction){
        return
      }
      var element = this.getElement()
      // console.log("body: "+ document.body.scrollTop + " par:"+document.documentElement.scrollTop)
      this.lastTop = element.scrollTop

      if(this.oldFinished)
        return;

      if(element.scrollTop>this.$refs.refLoadMore.clientHeight)
        return

      if(!this.oldLoading){
        this.oldLoading = true
        this.onLoad()
      }
    },
    getFlower(){
      return this.flower
    },
    flowerRemainTime(){
      let detTime = utils.detTime(this.flower.lastUpdateTime)
      if((detTime<60)&&(this.flower.count<10)){
        this.flower.remainTime = "免费(0:"+detTime+")"
      }else{
        this.flower.remainTime = '免费'
      }
      this.$emit("updateFlower", this.flower)
    },
    intervalCallBack(){
      //处理--花的倒计时
      this.flowerRemainTime()

      if(this.isAction){
        this.userId = wxAuth.getUserId()
        this.count++
        // console.log(this.count)
        if(this.count>3){
          this.getCommentNew();
          this.count = 0
        }
      }
    },
    getMsgTime(msgTickMs){
      //当前时间
      // let curData = new Date();
      // let curTickms = parseInt(curData.getTime())

      //当天--xx:xx
      //昨天--昨天 + xx:xx
      //周内--星期x + xx:xx
      //年内--x月x日

      let msgData = new Date(msgTickMs);
      let obj={
        'isShowMsgTime': true,
        'showMsgTime': '-',
        'time': msgTickMs  //必须加下，
      }
      if(utils.datesAreOnSameToday(msgData)){
        obj.showMsgTime = utils.date('H:i', parseInt(msgTickMs/1000))
      }else if(utils.datesAreOnSameYesterday(msgData)){
        obj.showMsgTime = "昨天 "+utils.date('H:i', parseInt(msgTickMs/1000))
      }else {
        obj.showMsgTime = utils.date('m月d日 H:i', parseInt(msgTickMs/1000))
      }
      // this.comments.push(obj)
      return obj
    },
    disposeNewTime(msgTickMs){
      let det = this.newMsgTime<msgTickMs ? (msgTickMs-this.newMsgTime) : (this.newMsgTime-msgTickMs)
      this.newMsgTime=msgTickMs
      if(det>(1000*60*3)){
        return this.getMsgTime(msgTickMs)
      }else{
        let obj = this.getMsgTime(msgTickMs)
        obj.isShowMsgTime = false
        obj.showMsgTime += "--------删"
        return obj
      }
    },
    disposeOldTime(msgTickMs){
      let det = this.oldMsgTime<msgTickMs ? (msgTickMs-this.oldMsgTime) : (this.oldMsgTime-msgTickMs)
      this.oldMsgTime=msgTickMs
      if(det>(1000*60*3)){
        return this.getMsgTime(msgTickMs)
      }else{
        let obj = this.getMsgTime(msgTickMs)
        obj.isShowMsgTime = false
        obj.showMsgTime += "--------删"
        return obj
      }
    },
    //获取最新评论
    getCommentNew(isFirst = false){
      if(this.newLoading==true){
        // console.log("正在处理，----获取最新评论,不能重复提交")
        return
      }
      // console.log("获取最新评论")
      this.newLoading=true
      let obj = {
        'id': this.liveId,
        'limit': this.limitMax,
      }
      if(this.comments.length!=0){
        obj.refreshTime = this.comments[this.comments.length-1].time
      }
      apiLive.getPlatformLiveComment(obj).then(res=>{
        if(res.comments.length!=0){
          if(isFirst){
            this.needResetPos = 1;
            this.newMsgTime = res.comments[res.comments.length-1].time
            this.oldMsgTime = this.newMsgTime
            this.comments.push(this.getMsgTime(this.newMsgTime))
          }else{
            this.needResetPos = 2;
            var element = this.getElement()
            this.lastTop = element.scrollTop
            this.lastHeight = element.scrollHeight
          }
        }else{
          if(isFirst){
            let curData = new Date();
            this.newMsgTime = parseInt(curData.getTime())
            this.oldMsgTime = this.newMsgTime

            this.newMsgTime = 0
          }
        }

        for (let i=0; i<res.comments.length; i++){
          //判断是否需要加时间节点
          let retObj = this.disposeNewTime(res.comments[res.comments.length-1-i].time)
          if(retObj.isShowMsgTime){
            this.comments.push(retObj)
          }

          res.comments[res.comments.length-1-i].isShowMsgTime = false
          this.comments.push(res.comments[res.comments.length-1-i])
        }
        // console.log((res))
        if(this.firstGetOld){
          this.getCommentOld()
        }

        //更新送花信息
        if(res.flower!=null){
          this.flower.count = res.flower.count
          this.flower.lastUpdateTime = res.flower.lastUpdateTime
        }
        this.count = 0
        this.newLoading = false;
      }).catch(err=>{
        this.newLoading = false;
      })
    },
    //获取历史评论
    getCommentOld(){
      let obj = {
        'id': this.liveId,
        'limit': this.limitMax,
      }
      // console.log("获取历史评论")
      if((this.comments.length!=0)){
        obj.lastTime = this.comments[0].time
        // console.log('old ----当前获取到的最后一条数据时间'+obj.lastTime)
      }
      apiLive.getPlatformLiveComment(obj).then(res=>{
        if(res.comments.length!=0){
          this.needResetPos = 3;
          var element = this.getElement()
          this.lastTop = element.scrollTop
          this.lastHeight = element.scrollHeight
        }
        for (let i=0; i<res.comments.length; i++){
          res.comments[i].isShowMsgTime = false
          this.comments.unshift(res.comments[i])

          let retObj = this.disposeOldTime(res.comments[i].time)
          if(retObj.isShowMsgTime){
            this.comments.unshift(retObj)
          }
        }

        // console.log((res))
        if(res.comments.length<this.limitMax){
          // console.log('历史获取结束')
          //看看是否要补上时间？？
          if((this.comments.length!=0)){
            if(!this.comments[0].isShowMsgTime){
              this.comments.unshift(this.getMsgTime(this.comments[0].time))
            }
          }
          this.oldFinished = true;
        }else{
          // console.log('历史获取还有更多数据')
          this.oldFinished = false;
        }
        // this.$refs['chat0'].scrollIntoView(true)
        this.oldLoading = false;
        this.firstGetOld = false;

        //测试，记得删除
        // this.oldFinished = true;
      }).catch(err=>{
        this.oldLoading = false;
        this.oldFinished = true;
      })
    },
    onLoad(){
      // //测试，记得删除
      // this.oldLoading = false;
      // this.oldFinished = true;
      // return

      setTimeout(()=>{
        this.getCommentOld()
      },500)
    },
    //评论
    commentLive(obj, callback){
      //判断是否已经登录
      if(wxAuth.check(this)==false){
        callback(false)
        return
      }
      if(this.comments.length!=0){
        obj.refreshTime = this.comments[this.comments.length-1].time
      }
      apiLive.commentLive(obj).then(res=>{
        // console.log("评论--------------------完成")
        // console.log(res)
        Toast({
          message: '发表成功',
          position: 'bottom',
        });
        callback(true)
        this.getCommentNew()
      }).catch(err=>{
        Toast({
          message: '发表失败',
          position: 'bottom',
        });
        callback(false)
      })
    },
    altSomeOne(obj){
      this.$emit("altSomeOne", obj)
    }
  }
}
</script>

<style scoped>
.lvChatListBox{
  position: relative;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 180px;
  height: 100%;
}
.loadMore{
  width: 100%;
  height: 80px;
  position: relative;
  /*background-color: #57ff73;*/
  text-align: center;
  line-height: 80px;
  font-size: 40px;
  color: #b2b2b2;
}
.refHeight{
  width: 100%;
  height: 50px;
  position: relative;
  /*background-color: #ff5777;*/
  /*top: 600px;*/
  z-index: 1;
}
</style>